import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import QuratorDashboard from './pages/QuratorDashboard';
import Library from './pages/Library';
import TrainerSimulations from './pages/TrainerSimulations';
import PublishedCopilots from './pages/PublishedCopilots';
import Drafts from './pages/Drafts';
import AIAssistant from './pages/AIAssistant';
import HelpDesk from './pages/HelpDesk';
import EditDraft from './pages/EditDraft';
import DraftRead from './pages/DraftRead';
import PlaySimulation from './pages/PlaySimulation';
import Projects from './pages/Projects';
import TeamManagement from './pages/TeamManagement';
import GlobalContext from './pages/GlobalContext';
import Calendar from './pages/Calendar';
import Analytics from './pages/Analytics';
import SupportTicket from './pages/SupportTicket';
import QureDashboard from './pages/QureDashboard';
import MyTeams from './pages/MyTeams';
import QureCalendar from './pages/QureCalendar';
import QureAnalytics from './pages/QureAnalytics';
import Profile from './pages/Profile';
import HumanValidation from './pages/HumanValidation';
import Telepresence from './pages/Telepresence';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

// Temporary placeholder pages (will be converted later)
function HomePage() {
  return <h1>Welcome to QureXR - Home Page</h1>;
}

function AboutPage() {
  return <h1>About QureXR</h1>;
}

function ContactPage() {
  return <h1>Contact Us</h1>;
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/telepresence" element={<Telepresence />} />
          
          {/* Protected Routes */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/qurator-dashboard" 
            element={
              <ProtectedRoute>
                <QuratorDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/library" 
            element={
              <ProtectedRoute>
                <Library />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/trainer-simulations" 
            element={
              <ProtectedRoute>
                <TrainerSimulations />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/published-copilots" 
            element={
              <ProtectedRoute>
                <PublishedCopilots />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/drafts" 
            element={
              <ProtectedRoute>
                <Drafts />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ai-assistant" 
            element={
              <ProtectedRoute>
                <AIAssistant />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/help-desk" 
            element={
              <ProtectedRoute>
                <HelpDesk />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/draft-edit" 
            element={
              <ProtectedRoute>
                <EditDraft />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/draft-read" 
            element={
              <ProtectedRoute>
                <DraftRead />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/play-simulation" 
            element={
              <ProtectedRoute>
                <PlaySimulation />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/projects" 
            element={
              <ProtectedRoute>
                <Projects />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/team-management" 
            element={
              <ProtectedRoute>
                <TeamManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/global-context" 
            element={
              <ProtectedRoute>
                <GlobalContext />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/calendar" 
            element={
              <ProtectedRoute>
                <Calendar />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/analytics" 
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/support" 
            element={
              <ProtectedRoute>
                <SupportTicket />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/qure-dashboard" 
            element={
              <ProtectedRoute>
                <QureDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/my-teams" 
            element={
              <ProtectedRoute>
                <MyTeams />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/qure-calendar" 
            element={
              <ProtectedRoute>
                <QureCalendar />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/qure-analytics" 
            element={
              <ProtectedRoute>
                <QureAnalytics />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/human-validation" 
            element={
              <ProtectedRoute>
                <HumanValidation />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin-dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Temporary routes */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Default redirect */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
